"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common = {
    timeout: 5000,
    jsonpCallback: 'findifyCallback',
};
exports.staging = __assign({}, common, { url: 'https://search-staging.findify.io/v3', retryCount: 1 });
exports.production = __assign({}, common, { url: 'https://api-v3.findify.io/v3', retryCount: 3 });
exports.development = exports.staging;
//# sourceMappingURL=settings.js.map